import { render, staticRenderFns } from "./jsgl.vue?vue&type=template&id=75f5bfa4&scoped=true"
import script from "./jsgl.vue?vue&type=script&lang=js"
export * from "./jsgl.vue?vue&type=script&lang=js"
import style0 from "./jsgl.vue?vue&type=style&index=0&id=75f5bfa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f5bfa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f5bfa4')) {
      api.createRecord('75f5bfa4', component.options)
    } else {
      api.reload('75f5bfa4', component.options)
    }
    module.hot.accept("./jsgl.vue?vue&type=template&id=75f5bfa4&scoped=true", function () {
      api.rerender('75f5bfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sysConfig/jsgl.vue"
export default component.exports